import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import { reportOpenSearchFilterPanel } from '../../../../common/analytics/filtersAnalytics'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'
import RulerIcon from '../../../shared/components/icons/ruler'
import RightOpenIcon from '../../../shared/components/icons/rightOpen'

const sizeFilterLabels = filterParamsConfig.sizes.labels

class FiltersSize extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Size')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render() {
    const { showPanel } = this.state
    const { items, locationParams, isAtTop, makeSearchLink } = this.props
    const chosenSizes = locationParams.sizes || ''

    const renderChosenSizes = () => {
      if (chosenSizes === '') {
        return (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              const label = sizeFilterLabels[item.key] || item.key
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">{label}</span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        const chosenSizesLabels = chosenSizes
          .split(',')
          .map(key => sizeFilterLabels[key] || key)
          .join(', ')
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              <div className="search-facet-panel__status-title">
                {chosenSizesLabels}
              </div>
            </div>
          </div>
        )
      }
    }

    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-panel__header': !isAtTop,
      'is-active': showPanel
    })

    // append the label to the items object
    const formatItems = items => {
      return items.map(item => {
        return {
          label: sizeFilterLabels[item.key] || item.key,
          ...item
        }
      })
    }

    const formattedItems = formatItems(items)

    return (
      <div className="search-facet--no-margin">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <RulerIcon /> Sizes
            <span style={{ float: 'right' }}>
              <RightOpenIcon />
            </span>
          </h2>
          {renderChosenSizes()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type="sizes"
                showPanel={showPanel}
                items={formattedItems}
                parsedLocation={locationParams}
                togglePanel={this.togglePanel}
                makeSearchLink={makeSearchLink}
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersSize.propTypes = {
  locationParams: PropTypes.object.isRequired,
  items: PropTypes.array,
  makeSearchLink: PropTypes.func.isRequired
}

export default FiltersSize
